import React from 'react';
import { Field, FastField, FieldProps } from 'formik';

import { observer } from 'mobx-react-lite';
import { useRegisteredRef } from 'src/lib/react-register-nodes';
import { Combobox, ComboboxProps } from 'src/kit';
import { FormikErrorMessage } from '../FormikErrorMessage';

export type FormikComboboxProps = ComboboxProps & { name: string; isFast?: boolean };

export const FormikCombobox = observer(({ isFast, name, value, onChange, ...rest }: FormikComboboxProps) => {
  const FieldComponent = isFast ? FastField : Field;
  const ref = useRegisteredRef(name);
  return (
    <FieldComponent name={name}>
      {({ field, form: { setFieldValue, setFieldTouched }, meta: { error, touched } }: FieldProps) => {
        const formikError = touched && typeof error === 'string' && error;

        return (
          <Combobox
            outerRef={error ? ref : undefined}
            name={name}
            value={value || field.value}
            onChange={v => {
              setFieldValue(name, v).then(() => {
                if (!touched) {
                  setFieldTouched(name, true, false);
                }
              });
              if (onChange) {
                onChange(v);
              }
            }}
            onBlur={() => {
              setFieldTouched(name, true);
            }}
            error={formikError}
            {...rest}
          >
            {formikError && <FormikErrorMessage name={name} />}
          </Combobox>
        );
      }}
    </FieldComponent>
  );
});
